module.exports = __webpack_public_path__ + "img/ks.f81130f6.png";